import {action} from 'mobx';

import objectAssignDeep from 'utils/object-assign-deep';

export const serialize = action('serialize', store =>
  JSON.parse(JSON.stringify(store)));
export const deserialize = action('deserialize', (store, object) =>
  objectAssignDeep(store, object, (target, source) => {
    if (target && typeof target.deserialize === 'function') {
      target.deserialize(source);
      return target;
    }
    return objectAssignDeep(target, source);
  }));



// WEBPACK FOOTER //
// ./spa/store.jsx